<template>
  <el-dialog
    :visible.sync="innerVisible"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    :title="$t('Menu.InitializeData')"
    width="600px"
  >
    <init-data-group :obj="obj" />
    <div slot="footer">
      <el-button type="primary" @click="closeHandler">{{ $t('Menu.Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import InitDataGroup from '@/views/cargo/v0/SystemMaintenance/components/sysMenu/InitDataGroup'
import * as initalDataApi from '@/api/sysManage/baseConfig/initalData'

export default {
  name: 'InitDataWindow',
  components: { cargoAdvanceSelect, InitDataGroup },
  props: {
    visible: { type: Boolean, required: true },
    obj: { type: Object, required: true }
  },
  data() {
    return {
      innerVisible: false,
      selectTypeNames: TYPE_NAMES,
      cboTenantId: null
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    initClickHandler(tableName, typeName) {
      const param = {}
      if (typeName) {
        param[typeName] = this.obj[typeName]
      } else {
        param[tableName] = this.obj[tableName]
      }
      param.TENANT_ID = this.obj.TENANT_ID
      param.COPY_TENANT_ID = this.obj.COPY_TENANT_ID
      param.uuid = this.obj.uuid
      const loading = getLoading()
      initalDataApi.updateInitalData(param).then(resp => {
        Object.assign(this.obj, resp.data)
      }).finally(() => loading.close())
    },
    closeHandler() {
      this.cboTenantId = ''
      this.$emit('close')
    }
  }
}
</script>

<style scoped>

</style>
